import Layout from "../../../components/Layout";
import PageTitle from "../../../components/PageTitle";
import { useEffect, useState } from "react";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import useWindowSize from "../../../hooks/useWindow";
import Table from "../../../components/Table/Table";
import { Icon } from "@iconify/react";
import Modal from "../../../components/Modal";
import { TableSearch } from "../../../components/Table/TableActions";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import Select from "react-select";
import BreadCrumb from "../../../components/BreadCrumb";
import PageLoader from "../../../components/PageLoader";
// import InputGroup from "../../../components/FormComponent/InputGroup";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/Button";
import useStyles from "../styles";
import nosearch from "../../../assets/images/no-search.svg";
import NoData from "../../dashboard/components/NotFoundCard/NoData";

const CLASSES_ENDPOINT = "/api/v1/class";
const STUDENT_ENDPOINT = "/api/v1/students";
const GET_GUARDIAN_ENDPOINT = "/api/v1/guardians";
const ASSIGN_GUARDIAN = "/api/v1/assign-guardians";

const AssignGuardian = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const [searchResult, setSearchResult] = useState([]);
  const [classesData, setClassData] = useState([]);
  const [guardian, setGuardian] = useState([]);
  const [selectedguardian, setSelectedGuardian] = useState([]);
  const [assigningGuardian, setAssigningGuardian] = useState(false);
  const [ispageFetching, setIsPageFetching] = useState(false);
  const [studentData, setStudentsData] = useState([]);
  const [filterStatus, setFilterStatus] = useState("");
  const [currentRow, setCurrentRow] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  //   const [filterStatus, setFilterStatus] = useState("");
  const width = useWindowSize();
  const mobile = width < 600;

  /**
 * Opens the delete confirmation modal for the selected row.
 *
 * @function handleDeleteModal
 * @param {Object} row - The data row to be deleted.
 */
  const handleDeleteModal = (row, index) => {
    setCurrentRow(row);
    setDeleteIndex(index);
    setDeleteModal(!deleteModal);
  };

  const handleDeleteGuardian = () => {
    setSelectedGuardian(prev => {
      const updated = [...prev];
      if (deleteIndex !== null) {
        updated.splice(deleteIndex, 1);
      }

      return updated;
    });
    setDeleteModal(false);
    setDeleteIndex(null);
    toast.success("Guardian assigned to student removed from the preview List.");
  };

  /**
 * Opens the delete confirmation modal for the selected row.
 *
 * @function handleDeleteModal
 * @param {Object} row - The data row to be deleted.
 */
  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setDeleteIndex(null);
  };

  /**
 * Handles changes in the ward multi-select dropdown.
 *
 * @function handleSingleWardChange
 * @param {Array} event - Selected ward options.
 */
  const handleSingleWardChange = ({ selectedGuardian, rowData, type }) => {
    if (!selectedGuardian) return;
    // if (rowData?.guardian?.guardian_id) {
    //   toast.info(`You are about to unassign ${rowData?.guardian?.last_name} ${rowData?.guardian?.first_name} from ${rowData?.student?.last_name} ${rowData?.student?.first_name}`);
    // }

    const newEntry = {
      student: rowData,
      guardian: selectedGuardian,
      type
    };

    setSelectedGuardian((prev) => {
      const exists = prev.some(
        (item) => item?.student?.student_id === newEntry?.student?.student_id &&
        item?.type === newEntry?.type
      );

      if (exists) {
        return prev.map((item) => {
          if (
            item?.student?.student_id === newEntry?.student?.student_id &&
          item?.type === newEntry?.type
          ) {
            return newEntry;
          }

          return item;
        });
      } else {
        return [...prev, newEntry];
      }
    });
  };

  /**
   * Fetches all guardians from the backend.
   *
   * @function getAllGuardian
   */
  const getAllGuardian = () => {
    // setIsPageFetching(true);
    httprequest.get(GET_GUARDIAN_ENDPOINT).then((res) => {
    //   setIsPageFetching(false);
      setGuardian(res?.data?.data?.map((guardian) => {
        return {
          label: `${guardian?.last_name} ${guardian?.first_name}`,
          value: guardian?.guardian_id
        };
      }));
    }).catch((err) => {
    //   setIsPageFetching(false);
      toast.error(err?.response?.data);
    });
  };

  /**
 * Handles filter changes for student data.
 * @function
 * @param {Object} e - The event object from the select input.
 */
  const handleFilterChange = (e) => {
    const { value } = e.target;
    setFilterStatus(value);

    // Filter guardians based on status when the filter is applied
    const filteredByStatus = value
      ? studentData?.filter((data) => data?.class?.id?.toLowerCase() === value?.toLowerCase())
      : studentData;

    setSearchResult(filteredByStatus);
  };

  /**
   * Fetches all physical classes from the server.
   * @function
   */
  const getAllClasses = () => {
    httprequest
      .get(CLASSES_ENDPOINT)
      .then((res) => {
        const physicalClasses = res?.data?.data?.filter(
          (data) => data?.class_type === "physical"
        );
        setClassData(physicalClasses);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  /**
   * Fetches all students and separates them into active/inactive categories.
   * Also handles loading state and error toasts.
   */
  const getAllStudents = () => {
    setIsPageFetching(true);
    httprequest.get(STUDENT_ENDPOINT).then((res) => {
    //   setIsStudentsFetching(false);
      // setStudentsData(res?.data?.data?.filter((activeStudent) => activeStudent?.is_active === true));
      // setSearchResult(res?.data?.data?.filter((activeStudent) => activeStudent?.is_active === true));
      setStudentsData(res?.data?.data);
      setSearchResult(res?.data?.data);
      setIsPageFetching(false);
    }).catch((err) => {
      setIsPageFetching(false);
      toast.error(err?.response?.data);
    });
  };

  const handleAssignGuardian = async () => {
    setAssigningGuardian(true);

    const groupedMap = new Map();

    selectedguardian?.forEach((item) => {
      const studentId = item?.student?.student?.id || item?.student?.student_id;
      const guardianType = item?.type;

      if (!studentId || !Array.isArray(item?.guardian) || !guardianType) return;

      if (!groupedMap.has(studentId)) {
        groupedMap?.set(studentId, []);
      }

      item.guardian.forEach((guardianObj) => {
        const guardianId = guardianObj?.value;

        if (!guardianId) return;

        groupedMap.get(studentId).push({
          guardian_id: guardianId,
          type: guardianType
        });
      });
    });

    const assignGuardianPayload = {
      assign_guardian: Array.from(groupedMap.entries()).map(
        ([student_id, guardians]) => ({
          student_id,
          guardians
        })
      )
    };

    try {
      const res = await httprequest.post(`${ASSIGN_GUARDIAN}`, assignGuardianPayload);
      toast.success(res?.data?.message || "Guardians assigned successfully!");
      setTimeout(() => {
        navigate("/users/guardians");
      }, 3000);
      setSelectedGuardian([]);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      setAssigningGuardian(false);
    }
  };

  // Define the columns for the Student table
  const columns = [
    {
      name: "Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Name</p>}
          {`${row?.student?.last_name || "--/--"} ${row?.student?.first_name || "--/--"}`}
        </>
      )
    },
    {
      name: "Class",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Class</p>}
          {row?.class?.name || "--/--"}
        </>
      )
    },
    {
      name: "Email",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Email</p>}
          {row?.email || "--/--"}
        </>
      )
    },
    {
      name: "Primary Guardian",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Primary Guardiant</p>}
          <div className="single-select">
            <Select
              isMulti
              key={`${row?.student?.id}`}
              defaultValue={row?.guardians
                ?.filter(g => g?.type === "primary")
                .map(g => ({
                  value: g?.guardian_id,
                  label: `${g?.first_name} ${g?.last_name}`
                }))}
              name="guardian"
              options={guardian}
              onChange={(selectedOption) => handleSingleWardChange({
                selectedGuardian: selectedOption,
                rowData: row,
                type: "primary"
              })
              }
              placeholder="Select a guardian"
              isClearable
              menuPortalTarget={document.body}
              styles={{
                menuPortal: base => ({ ...base, zIndex: 9 })
              }}
            />
          </div>
        </>
      )
    },
    {
      name: "Secondary Guardian",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Secondary Guardian</p>}
          <div className="single-select">
            <Select
              isMulti
              defaultValue={row?.guardians
                ?.filter(g => g?.type === "secondary")
                ?.map(g => ({
                  value: g?.guardian_id,
                  label: `${g?.first_name} ${g?.last_name}`
                }))}
              name="guardian"
              options={guardian}
              onChange={(selectedOption) => handleSingleWardChange({
                selectedGuardian: selectedOption,
                rowData: row,
                type: "secondary"
              })
              }
              placeholder="Select a guardian"
              isClearable
              menuPortalTarget={document.body}
              styles={{
                menuPortal: base => ({ ...base, zIndex: 9, width: "120px" })
              }}
            />
          </div>
        </>
      )
    }
  ];
  const previewcolumns = [
    {
      name: "Guardian Names",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Guardian Names</p>}
          <div className="single-select">
            <Select
              isMulti
              isDisabled
              value={row?.guardian
                ?.map(g => ({
                  value: g?.value,
                  label: g?.label
                }))}
              name="guardian"
              options={guardian}
              placeholder="Select a guardian"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: base => ({ ...base, zIndex: 9, width: "120px" })
              }}
            />
          </div>
        </>
      )
    },
    {
      name: "Student Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Student Name</p>}
          {`${row?.student?.student?.last_name || "--/--"} ${row?.student?.student?.first_name || "--/--"}`}
        </>
      )
    },
    {
      name: "Class",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Class</p>}
          {row?.student?.class?.name || "--/--"}
        </>
      )
    },
    {
      name: "Email",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Email</p>}
          {row?.student?.email || "--/--"}
        </>
      )
    },
    {
      name: "Guardian Role",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Guardian Role</p>}
          <div>
            <SelectGroup
              children={
                <select disabled value={row?.type} name="type">
                  <option value="">-- Select Role --</option>
                  <option value="primary">Primary</option>
                  <option value="secondary">Secondary</option>
                </select>
              }
            />
          </div>
        </>
      )
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row, index) => (
        <div key={row?.id} className="table-action-container">
          <button
            onClick={() => handleDeleteModal(row, index)}
            className="table-action-icon"
          >
            <div className="delete-icon"><Icon icon="mingcute:delete-2-line" /></div>
          </button>
        </div>
      )
    }
  ];
  // --| Filter Notice table using title, description, priority who can access
  const handleSearchStudent = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    const filteredByStatus = filterStatus
      ? studentData?.filter((data) => data?.class?.id?.toLowerCase() === filterStatus?.toLowerCase())
      : studentData;
    // --| Filter data by partial match onchange in the search input box
    const result = filteredByStatus?.filter((data) => valArray?.every(
      (word) => data?.class?.name?.toLowerCase().includes(word.toLowerCase()) ||
              data?.student?.first_name?.toLowerCase().includes(word.toLowerCase()) ||
              data?.student?.last_name?.toLowerCase().includes(word.toLowerCase()) ||
              data?.email?.toLowerCase().includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  useEffect(() => {
    getAllClasses();
    getAllStudents();
    getAllGuardian();
  }, []);

  return (
    <Layout children={
      <>
        <div className="breadcrumb-container">
          <div>
            <BreadCrumb
              link_one="/users/guardians"
              link_one_name="Guardians"
              active="Assign Batch Guardian"
              description="Batch preview wards and assign guardian"
            />
          </div>
        </div>
        <div className="page-content">
          <div className="parent-guardian adjust-table">
            <div className="item-border child-guardian">
              <PageTitle
                title="Assign Guardian"
                subtitle="Fill in the details below to assign Guardians to a Student"
              />
              {ispageFetching ? (
                <PageLoader />
              ) : (
                <Table
                  data={searchResult}
                  columns={columns}
                  subHeader={true}
                  isScrollable={true}
                  subHeaderComponent={
                    <div className="action_div">
                      <TableSearch
                        placeholder="Search Student..."
                        searchTableFunc={handleSearchStudent}
                      />
                      <div>
                        <SelectGroup
                          children={
                            <select onChange={handleFilterChange}>
                              <option value="">---Select---</option>
                              {classesData?.map((data) => {
                                return (
                                  <option key={data?.id} value={data?.id}>
                                    {data?.class_name}
                                  </option>
                                );
                              })}
                            </select>
                          }
                        />
                      </div>
                    </div>}
                />
              )}
            </div>
            <div className="item-border child-guardian">
              <PageTitle
                title="Preview Changes"
              />
              {selectedguardian?.length > 0 ? (
                <div>
                  <Table
                    data={selectedguardian}
                    columns={previewcolumns}
                    subHeader={true}
                    isScrollable={true}
                    subHeaderComponent={
                      <div className="action_div">
                        <TableSearch
                          disabled
                          placeholder="Search Student..."
                          searchTableFunc={handleSearchStudent}
                        />
                      </div>}
                  />
                </div>
              ) : (
                <div className={classes?.notfound}>
                  <NoData img={nosearch} title="No Guardian has been selected" subtitle="No Guardian has been added to the list for previewing." />
                </div>
              )}

            </div>
          </div>
          <div className="flex gap-10 margin-top-12">
            <Button onClick={() => {
              navigate("/users/guardians");
            }} variant="primaryoutline" buttonSize="medium" color="btnfontprimary" buttonName="Back"
            />
            <Button isLoading={assigningGuardian} onClick={handleAssignGuardian} variant="primary" buttonSize="medium" color="btndefault" buttonName="Assign Guardians" />
          </div>
        </div>
        {/* Delete Modal */}
        <Modal
          title="Unassign Guardian from Student"
          subtitle={
            <div>
    Are you sure you want to unassign
              {/* <span className="modal-name-highlight"> {`${currentRow?.guardian?.label}`}</span> */}
              {" "}from
              <span className="modal-name-highlight"> {` ${currentRow?.student?.student?.last_name} ${currentRow?.student?.student?.first_name}`}</span>?
    You can reassign this guardian later if needed.
            </div>
          }
          modalContent={
            <>

            </>
          }
          modalFooter={
            <>
              <Button variant="danger" onClick={handleDeleteGuardian} buttonName="Unassign Guardian from List" buttonSize="full" color="btndefault" />
            </>
          }
          isopen={deleteModal}
          closeModal={handleCloseDeleteModal}
        />
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default AssignGuardian;
